export const START_COUNTING = "timing/START_COUNTING";
export const END_COUNTING = "timing/END_COUNTING";
export const END_COUNTING_FINISH = "timing/END_COUNTING_FINISH";
export const SAVE_COUNTING = "timing/SAVE_COUNTING";
export const SAVE_REMAIN_TIME = "timing/SAVE_REMAIN_TIME";
export const SET_IS_COUNTING_TIME = "timing/SET_IS_COUNTING_TIME";
